import { render, staticRenderFns } from "./CurriculumArticolazioni.vue?vue&type=template&id=4b971c38&scoped=true&"
import script from "./CurriculumArticolazioni.vue?vue&type=script&lang=ts&"
export * from "./CurriculumArticolazioni.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumArticolazioni.vue?vue&type=style&index=0&id=4b971c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b971c38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
